import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "../../context/AppContext";
import * as api from "../../lib/api";

export function LocalLoginPage() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const { setAuthUser } = useApp();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            const user = await api.authLogin(email, password);
            setAuthUser(user);
            navigate("/", { replace: true });
        } catch (err) {
            const detail = err.response?.data?.detail;
            if (typeof detail === "string") {
                setError(detail);
            } else if (Array.isArray(detail)) {
                setError(detail.map((e) => e.msg || JSON.stringify(e)).join(" "));
            } else {
                setError("Identifiants incorrects");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4" data-testid="local-login-page">
            <div className="w-full max-w-sm">
                {/* Logo */}
                <div className="flex justify-center mb-10">
                    <img
                        src="/logo-eggtelsa.webp"
                        alt="EGG TELSA"
                        className="h-20 object-contain"
                        data-testid="local-login-logo"
                    />
                </div>

                {/* Card */}
                <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
                    <h1 className="text-xl font-semibold text-gray-900 text-center mb-2">
                        Connexion locale
                    </h1>
                    <p className="text-sm text-gray-500 text-center mb-6">
                        Accès administrateur
                    </p>

                    <form onSubmit={handleSubmit} className="space-y-4">
                        {error && (
                            <div className="bg-red-50 border border-red-200 text-red-700 text-sm px-4 py-3 rounded-lg" data-testid="login-error">
                                {error}
                            </div>
                        )}

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1.5">
                                Adresse e-mail
                            </label>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="admin@eggtelsa.com"
                                className="w-full px-3 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-gray-900 focus:border-transparent"
                                required
                                autoFocus
                                data-testid="local-login-email"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1.5">
                                Mot de passe
                            </label>
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="••••••••"
                                className="w-full px-3 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-gray-900 focus:border-transparent"
                                required
                                data-testid="local-login-password"
                            />
                        </div>

                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full px-4 py-2.5 bg-gray-900 hover:bg-gray-800 disabled:bg-gray-400 text-white rounded-lg font-medium text-sm transition-colors"
                            data-testid="local-login-submit"
                        >
                            {loading ? "Connexion..." : "Se connecter"}
                        </button>
                    </form>
                </div>

                <p className="text-xs text-gray-400 text-center mt-6">
                    EGG TELSA — Électricité · Télécom
                </p>
            </div>
        </div>
    );
}
